import { TSiteTemplate } from '../../../../types';
import * as config from '../../../../config';

export const templates: Record<string, TSiteTemplate> = {
  'default-page-loading': {
    id: 'default-page-loading',
    name: 'default-page-loading',
    locale: config.app.default.locale,
    template: [
      {
        tag: 'head',
        children: {
          tag: '$Template',
          name: 'default-markup-head',
        },
      },
      {
        tag: 'body',
        className: 'bg-primary d-flex align-items-center justify-content-center',
        style: {
          minHeight: '100vh',
        },
        children: {
          tag: 'div',
          className: 'mx-auto my-auto text-center',
          children: [
            {
              tag: '$Icon',
              icon: 'default-spinner',
              className: 'spinner-border border-0',
            },
            {
              tag: 'p',
              className: 'mb-0',
              children: 'Загрузка...',
            },
          ],
        },
      },
    ],
  },
  'default-page-uc': {
    id: 'default-page-uc',
    name: 'default-page-uc',
    locale: config.app.default.locale,
    template: [
      {
        tag: 'head',
        children: {
          tag: '$Template',
          name: 'default-markup-head',
        },
      },
      {
        tag: 'body',
        className: 'bg-primary d-flex align-items-center justify-content-center',
        style: {
          minHeight: '100vh',
        },
        children: {
          tag: 'div',
          className: 'mx-auto my-auto',
          children: {
            tag: 'div',
            className: 'alert alert-info mb-0 shadow text-center',
            children: [
              {
                tag: 'p',
                className: 'display-5',
                children: 'Ведутся работы',
              },
              {
                tag: '$Icon',
                icon: 'default-spinner',
                className: 'spinner-border border-0',
              },
              {
                tag: 'p',
                className: 'mb-0',
                children: 'В данный момент раздел не доступен, попробуйте зайти позже',
              },
            ],
          },
        },
      },
    ],
  },
  'default-page-error': {
    id: 'default-page-uc',
    name: 'default-markup-error',
    locale: config.app.default.locale,
    template: [
      {
        tag: 'head',
        children: {
          tag: '$Template',
          name: 'default-markup-head',
        },
      },
      {
        tag: 'body',
        className: 'bg-primary d-flex align-items-center justify-content-center',
        style: {
          minHeight: '100vh',
        },
        children: {
          tag: 'div',
          className: 'mx-auto my-auto',
          children: {
            tag: 'div',
            className: 'alert alert-danger mb-0 shadow text-center',
            children: [
              {
                tag: 'p',
                className: '',
                children: 'Ошибка',
              },
              {
                tag: 'p',
                className: 'display-3',
                children: '404',
              },
              {
                tag: 'p',
                className: 'mb-0',
                children: 'Страница не найдена...',
              },
            ],
          },
        },
      },
    ],
  },
  'default-markup-head': {
    id: 'default-page-uc',
    name: 'default-markup-head',
    locale: config.app.default.locale,
    template: [
      {
        tag: 'meta',
        name: 'viewport',
        content: 'width=device-width, initial-scale=1',
      },
      {
        tag: 'link',
        rel: 'apple-touch-icon',
        sizes: '152x152',
        href: '/assets/images/apple-touch-icon.png',
      },
      {
        tag: 'link',
        rel: 'icon',
        type: 'image/png',
        sizes: '32x32',
        href: '/assets/images/favicon-32x32.png',
      },
      {
        tag: 'link',
        rel: 'icon',
        type: 'image/png',
        sizes: '16x16',
        href: '/assets/images/favicon-16x16.png',
      },
      {
        tag: 'link',
        rel: 'mask-icon',
        color: '#5bbad5',
        href: '/assets/images/safari-pinned-tab.svg',
      },
      {
        tag: 'meta',
        name: 'msapplication-TileColor',
        content: '#da532c',
      },
      {
        tag: 'meta',
        name: 'theme-color',
        content: '#ffffff',
      },
      {
        tag: 'link',
        rel: 'manifest',
        href: '/site.webmanifest',
      },
      {
        tag: 'link',
        rel: 'stylesheet',
        href: '/assets/css/bootstrap.min.css',
      },
    ],
  },
};
